/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxNapoliPizzaOvenComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxNapoliPizzaOven').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'OVEN_LYNX_NAPOLI_LPZA',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-napoli-pizza-oven.js.map